module.exports = __webpack_public_path__ + "img/sortImg1-3.98d86a41.png";